import { WopListResponseType } from '@/common/types/ApiResponseTypes.type.ts';
import { fetchApi } from '@/config/axiosSetting.ts';
import { getIncidentTypesProps } from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/property/incidetDetailsCauseQueryProperty.types';

export const getIncidentTypes = ({
  fa_name,
  insurance,
}: getIncidentTypesProps): Promise<WopListResponseType[]> => {
  return fetchApi({
    method: 'GET',
    url: '/selection_item/cause/wop_list/',
    params: { fa_name, page: 1, insurance },
  });
};
